import createBrowserHistory from 'history/lib/createBrowserHistory';
import createRouterHistory from './createRouterHistory';
export default createRouterHistory(createBrowserHistory);


//////////////////
// WEBPACK FOOTER
// ../~/react-router/es/browserHistory.js
// module id = 1251
// module chunks = 0